import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

const ProjectActionButton = ({ onClick, isGrey, ...props }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <Button
      iconOnly
      grey={isGrey}
      aria-label="Add item"
      onClick={handleClick}
      {...props}
    >
      <MaterialIcon id="more_horiz" />
    </Button>
  );
};

ProjectActionButton.propTypes = {
  onClick: PropTypes.func,
  isGrey: PropTypes.bool,
};

PropTypes.defaultProps = {
  onClick: () => {
    // TODO Integrate with Mercury for move project
  },
  isGrey: false,
};

export default ProjectActionButton;
